<template>
  <div style="height: 100%;">
    <div  v-if="!isSignupFailed" class="signuplayout">
      <div v-if="!isLoading">
        <div v-if="!isCompanySelected">
          <span class="logintext">{{labels.selectCompany}}</span>
          <span v-if="!showValidatedCompany" class="logintextsubtitle">{{ showValidatedCompany ? labels.validateCompanyText : labels.selectCompanySubTitleText}} </span>
          <div class="signupform">
            <v-layout row>
              <v-flex xs12>
                <CompanySelector id="companySelector" ref="companySelector" :countryFlag="companyCountryFlag" :selectedCountry="companyCountry" :companyTitle="companyTitle" :countries="allowedCountries" @validateForm="validateForm" @selectedCountryChanged="companyCountryChanged" />
              </v-flex>
            </v-layout>
            <br>
            <v-layout v-if="showValidatedCompany" row>
              <div class="validatecompany">
                <v-btn block type="submit" color="primary" @click="validateCompany">{{labels.btnMyCompany}}</v-btn>
                <br>
                <span style="text-align: center;">
                  <a v-on:click='backToSearch' >{{labels.btnBackToSearch}}</a>
                </span>
              </div>
            </v-layout>
            </div>
        </div>
        <div v-if="isCompanySelected">
          <SignupConfirmationFinalStep v-if="!signupFailed" ref="signup" :passwordRules="passwordRules" @signup="signup" />
        </div>
      </div>
      <div v-if="isLoading" class="coverloading text-xs-center" style="margin-top: 26%;">
        <span class="coverprogress">
          <v-progress-circular :size="100" indeterminate color="primary"></v-progress-circular>
        </span>
      </div>
    </div>
    <div v-if="isSignupFailed" class="confirmationlayout" style="text-align: center;">
      <span class="signupconfirmationtitle">{{labels.companyAlreadyRegistred}}</span>
      <span class="signupconfirmationsubtitle">{{labels.contactUsText}}  <a v-bind:href="'mailto:'+config.contactUs">{{config.contactUs}} </a>  </span>
      <br/>
      <span style="text-align: center;">
        <a v-on:click='backToSearch' >{{labels.btnBackToSearch}}</a>
      </span>
    </div>
  </div>

</template>
<script>
import CompanySelector from '@/components/cover/newcover/company/CompanySelector'
import SignupConfirmationFinalStep from '@/components/login/SignupConfirmationFinalStep'
import accountApi from '@/services/AccountApi'
import { BusinessException } from '@/services/ErrorHandler'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      labels: {
        selectCompany: this.$t('Login.SignUp.SELECT_COMPANY_TITLE'),
        selectCompanySubTitleText: this.$t('Login.SignUp.SELECT_COMPANY_DESC'),
        validateCompanyText: this.$t('Login.SignUp.VALIDATE_COMPANY_DESC'),
        btnMyCompany: this.$t('Login.SignUp.THIS_IS_MY_COMPANY_BTN'),
        btnBackToSearch: this.$t('Login.SignUp.BACK_TO_SEARCH_LINK'),
        companyAlreadyRegistred: this.$t('Login.SignUp.COMPANY_ALREADY_REGISTRED_ERROR'),
        contactUsText: this.$t('Login.SignUp.CONTACT_US_DESC')
      },
      isLoading: true,
      companyCountry: '',
      companyTitle: '',
      showValidatedCompany: false,
      isCompanySelected: false,
      registrationToken: '',
      signupFailed: false,
      companyId: ''
    }
  },
  methods: {
    async verfiyUserToken () {
      this.registrationToken = this.$route.query.token
      if (this.registrationToken) {
        this.$store.dispatch('userdetails/setUserRegistrationToken', this.registrationToken)
        let data = await accountApi.retrieveUserTokenInfo()
        this.companyCountry = data.countryCode
        this.isLoading = false
      }
    },
    validateForm () {
      this.showValidatedCompany = true
    },
    companyCountryChanged (country) {
      this.companyCountry = country.code
    },
    validateCompany () {
      this.isCompanySelected = true
      this.companyId = this.$refs.companySelector.getCompanyId()
    },
    backToSearch () {
      if (this.$refs.companySelector) {
        this.$refs.companySelector.setSearchMode()
      }
      this.showValidatedCompany = false
      this.isCompanySelected = false
      this.signupFailed = false
      this.companyId = ''
    },
    async signup (userInfos) {
      try {
        if (this.$refs.signup.isFormValid()) {
          await accountApi.registerUser(userInfos, this.registrationToken, this.companyId)
          this.$store.dispatch('global/setSnackbar', {
            show: true,
            color: 'success',
            text: this.$t('Login.SignUp.SUCCESSFUL_REGISTRATION_DESC'),
            timeout: 6000
          })
          this.$router.push({ path: 'login' })
        }
      } catch (err) {
        if (err instanceof BusinessException) {
          this.signupFailed = true
          this.$refs.signup.signupCompleted()
        } else {
          this.$refs.signup.signupFailed()
        }
        throw err
      }
    }
  },
  async mounted () {
    await this.verfiyUserToken()
  },
  components: {
    CompanySelector,
    SignupConfirmationFinalStep
  },
  computed: {
    ...mapState('countries', ['allowedRegistrationCountries']),
    ...mapState('accounts', ['passwordRules']),
    ...mapState('siteconfig', ['config']),
    companyCountryFlag: function () {
      let result = this.allowedRegistrationCountries.find(f => f.countryCode.toUpperCase() === this.companyCountry.toUpperCase())
      return result ? result.countryFlag : ''
    },
    allowedCountries: function () {
      if (!this.allowedRegistrationCountries) {
        return []
      }
      let result = this.allowedRegistrationCountries.map(c => {
        return {
          code: c.countryCode,
          flag: c.countryFlag
        }
      })
      return result
    },
    isSignupFailed: function () {
      return !this.isLoading && this.isCompanySelected && this.signupFailed
    }
  }
}
</script>
<style>
.signuplayout {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
  max-width: 438px;
  margin: auto;
  height: 30%;
}
.signupform{
  margin-top : 30px
}
.signupform .selectedcompany{
  margin-left: 48px;
}
.validatecompany {
  display: flex;
  flex-direction: column;
  width: 82%;
  margin: auto;
  height: 88px;
}
</style>
